export default __webpack_public_path__ + "static/media/csv.e622a63d.svg";